import { FormContent } from '../bookingConfirmationCard/bookingConfirmationFun';

const RenderFormContent = ({ data }) => {
    return (
        <>
            {data.map((item, index) => (
                <FormContent
                    key={index}
                    id='extraStyle'
                    label={item.label}
                    answer={item.answer}
                    className='borderNone width30'
                />
            ))}
        </>
    );
};

export default RenderFormContent;
